import axios from "axios";
import { myAccountUrl, deleteProfileImageUrl, updateAccountUrl } from "../urls";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
export const getAccountDetailsAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(myAccountUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch account details' 
      });
    }
  });
};

export const updateAccountDetailsAction = async (data) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.patch(updateAccountUrl(), data, getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to update account details' 
      });
    }
  });
};

export const deleteProfileImageAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.delete(deleteProfileImageUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to delete profile image' 
      });
    }
  });
};